import { formatPrice } from "@/lib/api";

const attemptStyle = {
  Paid: "bg-[#dcfce7] text-[#15803d]",
  Ordered: "bg-[#dcfce7] text-[#15803d]",
  Failed: "bg-[#fee2e2] text-[#b91c1c]",
  "SMS Failed": "bg-[#fee2e2] text-[#b91c1c]",
  "Wrong OTP": "bg-[#fee2e2] text-[#b91c1c]",
  Cancelled: "bg-[#fef9c3] text-[#a16207]",
  "Not Ordered": "bg-[#fef9c3] text-[#a16207]",
  Pending: "bg-[#F8DAD7] text-[#A01F1F]",
  "OTP Sent": "bg-[#F8DAD7] text-[#A01F1F]",
  Verified: "bg-[#e0f2fe] text-[#0369a1]",
  Abandoned: "bg-slate-100 text-[#475569]",
};

const fmtTime = (ts) =>
  new Date(ts).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export const AttemptsTable = ({ title, icon: Icon, rows, testid, rowPrefix, empty }) => (
  <div className="bg-white rounded-sm fk-shadow overflow-hidden" data-testid={testid}>
    <div className="flex items-center gap-2 px-4 py-3 border-b border-[#f0f0f0] bg-[#f8fafc]">
      <Icon className="w-4 h-4 text-[#C62828]" />
      <h2 className="font-head font-bold text-[#0f172a] text-base">{title}</h2>
    </div>
    {rows.length === 0 ? (
      <div className="px-4 py-10 text-center text-sm text-[#64748b]" data-testid={`${testid}-empty`}>{empty}</div>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-[#64748b] border-b border-[#f0f0f0]">
              {["Time", "Phone", "Items", "Amount", "Status", "Reason"].map((h) => (
                <th key={h} className="px-4 py-2 font-medium">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((a, i) => (
              <tr key={i} className="border-b border-[#f8fafc] last:border-0" data-testid={`${rowPrefix}-${i}`}>
                <td className="px-4 py-2.5 text-[#475569] whitespace-nowrap">{fmtTime(a.ts)}</td>
                <td className="px-4 py-2.5 text-[#0f172a]">{a.phone}</td>
                <td className="px-4 py-2.5 text-[#475569] max-w-[220px] truncate">{a.items_summary || "—"}</td>
                <td className="px-4 py-2.5 font-medium text-[#0f172a]">{a.amount ? formatPrice(a.amount) : "—"}</td>
                <td className="px-4 py-2.5">
                  <span className={`text-xs font-semibold px-2 py-1 rounded-sm ${attemptStyle[a.status] || "bg-slate-100 text-[#475569]"}`}>
                    {a.status}
                  </span>
                </td>
                <td className="px-4 py-2.5 text-xs text-[#64748b]">
                  {a.reason === "cancelled" ? "Customer closed the payment popup" : a.reason || "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);
